import { IUserInChatListSchema } from '../types/userData';

interface IGetReplyAuthorNameProps {
  users: IUserInChatListSchema[];
  userId: number;
}

/**
 * @description
 * Возвращает имя автора сообщения
 */
export const getReplyAuthorName = ({ users, userId }: IGetReplyAuthorNameProps): string => {
  const user = users.find(u => u.userId === userId);

  return user?.name || '';
};
